import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { classficationOptions } from 'forms/admin/building/filter/classfication'
import Modalhandler from 'components/shared/modal/modal-handler'
import Modal from 'components/shared/modal'

const Field = ({ data, index }) => {
  const classification = classficationOptions.find((item) => item.value === data.value)
  return (
    <div className={`md:w-2/4 w-full inline-block mb-4 md:p${index % 2 ? 'l' : 'r'}-4`}>
      <p className="text-secondary-greylabel">{data.label ?? ''}</p>
      <p className="border-dashed border-b border-gray-400 ">
        {classification ? classification.name : data.value}
      </p>
    </div>
  )
}
Field.propTypes = {
  data: PropTypes.object,
  index: PropTypes.number,
}
const ModalField = ({ data }) => {
  const classification = classficationOptions.find((item) => item.value === data.value)

  return (
    <div className="mb-2 flex items-start">
      <span className="inline-block text-secondary-greylabel w-7/12">{data.label ?? ''}</span>
      <span className="inline-block w-5/12">
        {classification ? classification.name : data.value}
      </span>
    </div>
  )
}
ModalField.propTypes = {
  data: PropTypes.object,
}
const InformationForm = ({ information = [], buildingName = '' }) => {
  const [about = [], accessAndParking = [], floorSpaces = []] = information
  const maximumDisplay = 4;
  const showAllBtn = about.length > maximumDisplay || accessAndParking.length > maximumDisplay || floorSpaces.length > maximumDisplay

  if (information.length) {
    for (let i = 0; i < information[0].length; i++) {
      if (information[0][i].label === 'Tenure') {
        if (information[0][i].value === '99_year_leasehold') information[0][i].value = '99-year leasehold'
        if (information[0][i].value === '999_year_leasehold') information[0][i].value = '999-year leasehold'
      }
    }
  }

  return (
    <div className="pt-25px">
      <h2 className="mt-2 font-bold text-2xl">Building information</h2>
      <h3 className="block my-2 text-lg font-bold">About {buildingName}</h3>
      {about.map((item, index) => index < maximumDisplay && <Field key={index} index={index} data={item} />)}
      <h3 className="block my-2 text-lg font-bold">Building Access and Parking</h3>
      {accessAndParking.map(
        (item, index) => index < maximumDisplay && <Field key={index} index={index} data={item} />
      )}
      <h3 className="block my-2 text-lg font-bold">Floor Spaces</h3>
      {floorSpaces.map((f, index) => index < maximumDisplay && <Field key={index} index={index} data={f} />)}

      {
        // Show all properties button
        showAllBtn && (
          <div className="flex items-center justify-start w-full">
            <Modalhandler
              className="btn border border-primary-orange  text-primary-orange rounded-lg flex items-center justify-center"
              title="Show all properties"
            >
              {({ toggle }) => (
                <Modal onClose={toggle}>
                  <div className="rounded px-4 ">
                    <h2 className="mt-2 font-bold">Building information</h2>
                    <div className="building-page-content">
                      <h3 className="block mt-6 mb-2 text-lg font-bold">
                        About {buildingName}
                      </h3>
                      {about.map((item, key) => (
                        <ModalField key={key} data={item} />
                      ))}
                      <h3 className="block mt-4 mb-2  text-lg font-bold">Building Access</h3>
                      {accessAndParking.map((item, key) => (
                        <ModalField key={key} data={item} />
                      ))}
                      <h3 className="block mt-4 mb-2 text-lg font-bold">Floor Spaces</h3>
                      {floorSpaces.map((item, key) => (
                        <ModalField key={key} data={item} />
                      ))}
                    </div>
                  </div>
                </Modal>
              )}
            </Modalhandler>
          </div>
        )
      }
    </div>
  )
}

InformationForm.propTypes = {
  information: PropTypes.array,
  buildingName: PropTypes.string,
  buildingUses: PropTypes.array,
}

const mapStateToProps = ({ building }) => {
  return {
    information: building.public.details.building_information?.details ?? [],
    buildingName: building.public.details.name,
    buildingUses: building.public.details.building_information?.buildingUses,
  }
}

export default connect(mapStateToProps)(InformationForm)
